import { render, staticRenderFns } from "./CampaignsAdsGridContent.vue?vue&type=template&id=70827cc6"
import script from "./CampaignsAdsGridContent.vue?vue&type=script&lang=ts"
export * from "./CampaignsAdsGridContent.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsAdsGridContent.vue?vue&type=style&index=0&id=70827cc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports